// CX-49381: when the sign-up URL carries eid=1, the COR dropdown offers only
// FXCM_EU countries. CX-51076: countries listed in restrictedCountries.json
// `euOnlyExcluded` are kept out of that list without changing their entity in
// countryList.json (which other screens and the country-blocked entity lookup
// rely on). A missing/invalid `euOnlyExcluded` excludes nothing.
export const EU_ONLY_ENTITY_CODE = "FXCM_EU";

export const getEuOnlyCountryList = (countries, excludedCountries) => {
	const excluded = new Set(
		(Array.isArray(excludedCountries) ? excludedCountries : []).map((code) => String(code).toUpperCase())
	);
	return (Array.isArray(countries) ? countries : []).filter(
		(item) =>
			item?.entity_code === EU_ONLY_ENTITY_CODE &&
			!excluded.has(String(item?.country_code).toUpperCase())
	);
};
